import * as React from 'react';
import classNames from 'classnames';

interface Props {
  position?: ChevronPosition;
}

export enum ChevronPosition {
  Left = 'left',
  Right = 'right',
}

const Chevron = ({ position = ChevronPosition.Left }: Props) => (
  <svg
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('chevron', { right: position === ChevronPosition.Right })}
  >
    <title>chevron left</title>
    <desc>chevron left icon</desc>
    <g id="f8f28_Icons" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g id="f8f28_Artboard" transform="translate(-135.000000, -281.000000)" />
      <g id="f8f28_chevron-left">
        <mask id="f8f28_mask-2">
          <polygon id="f8f28_path-1" points="15.41 16.58 10.83 12 15.41 7.41 14 6 8 12 14 18" />
        </mask>
        <polygon id="f8f28_path-1" points="15.41 16.58 10.83 12 15.41 7.41 14 6 8 12 14 18" />
      </g>
    </g>
  </svg>
);

export default Chevron;



// WEBPACK FOOTER //
// ./src/components/Icons/Chevron/Chevron.tsx